module.exports = __webpack_public_path__ + "img/bg.cd31a342.png";